// CanvaPopup.jsx (class-based, condensed example)
import React, { Component } from 'react';
import axios from 'axios';
import { generatePKCEPair } from './pkceUtils';
import { CANVA_CLIENT_ID, CANVA_REDIRECT_ORIGIN, CANVA_REDIRECT_URI, isAllowedCanvaAppOrigin } from './canvaOAuthConfig';
import * as ETVConstants from '../ETVConstants.js';

//important!!! otherwise it will mount twice (in dev mode)
//for testing: need to test on 127.0.0.1 (localhost would fail)
let hasMounted = false; 

class CanvaPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 'initializing', // "initializing" | "exchanging" | "done" | "error"
      error: null,
      codeVerifier:'',
      isAuthInitiated: false,
      isExchanging: false,
    };
  }

  async componentDidMount() {
    if (hasMounted) {
      //console.log("CanvaPopup already mounted. Skipping...");
      return;
    }
    hasMounted = true; 
    if (this.state.isAuthInitiated) {
      //console.log("Auth process already initiated. Skipping...");
      return;
    }
    this.setState({ isAuthInitiated: true });
    //console.log("--------> component did mount");
  
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
	const oauthError = params.get('error');
	const returnedState = params.get('state');
	const openerOrigin = params.get('opener_origin');
	if (openerOrigin && isAllowedCanvaAppOrigin(openerOrigin)) {
	  sessionStorage.setItem('canvaOAuthOpenerOrigin', openerOrigin);
	}

	if (oauthError) {
	  this.setState({ step:'error', error:params.get('error_description') || oauthError });
	  return;
	}
  
    if (!code || code.length === 0 || code === 'undefined') {
	  if (openerOrigin && isAllowedCanvaAppOrigin(openerOrigin) && window.opener) {
		window.addEventListener('message', this.handleOAuthInitMessage, false);
		window.opener.postMessage({type:'canva_popup_ready'}, openerOrigin);
		return;
	  }
	  this.initializeOAuth();
    } else {
	  const storedState = localStorage.getItem('canvaOAuthState');
	  const storedVerifier = localStorage.getItem('canvaCodeVerifier');
	  if (!storedState || !storedVerifier || (returnedState && returnedState !== storedState)) {
		this.setState({step:'error',error:'Invalid OAuth state. Please close this window and try again.'});
		return;
	  }
      this.setState({ step: 'exchanging' });
      this.exchangeCodeForTokens(code);
    }
  }

  componentWillUnmount() {
	window.removeEventListener('message', this.handleOAuthInitMessage, false);
  }

  handleOAuthInitMessage = (event) => {
	const openerOrigin = sessionStorage.getItem('canvaOAuthOpenerOrigin');
	if (!openerOrigin || event.origin !== openerOrigin || !isAllowedCanvaAppOrigin(event.origin) || event.data?.type !== 'canva_oauth_init') return;
	if (!event.data.userId || !event.data.accessToken) {
	  this.setState({step:'error', error:'Your portal session is missing. Please sign in again and retry the Canva import.'});
	  return;
	}
	sessionStorage.setItem('canvaOAuthUserId', event.data.userId);
	sessionStorage.setItem('canvaOAuthAccessToken', event.data.accessToken);
	window.removeEventListener('message', this.handleOAuthInitMessage, false);
	this.initializeOAuth();
  };

  initializeOAuth = async () => {
	try {
	  const { codeVerifier, codeChallenge } = await generatePKCEPair();
	  localStorage.setItem('canvaCodeVerifier', codeVerifier);
	  localStorage.setItem('canvaCode', codeChallenge);
	  const state = Array.from(window.crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('');
	  localStorage.setItem('canvaOAuthState', state);
	  this.startCanvaOAuth();
	} catch (err) {
	  this.setState({ step: 'error', error: `Failed to generate PKCE pair: ${err.message}` });
	}
  };

  startCanvaOAuth() {
    try {
      var codeChallenge = localStorage.getItem('canvaCode');
      //alert("code sent: "+codeChallenge);
      // Build the auth URL
      const clientId = CANVA_CLIENT_ID;
      var authUrl = "https://www.canva.com/api/oauth/authorize";
      authUrl+="?code_challenge="+codeChallenge;
      authUrl+="&code_challenge_method=s256";
      authUrl+="&scope="+encodeURIComponent("design:meta:read folder:read asset:read asset:write design:content:read");
      authUrl+="&response_type=code";
      authUrl+="&client_id="+clientId;
	  authUrl+="&state="+encodeURIComponent(localStorage.getItem('canvaOAuthState'));
	  authUrl+="&redirect_uri="+encodeURIComponent(CANVA_REDIRECT_URI);
      //console.log("authURL="+authUrl);

      // Redirect this popup to Canva
      window.location.href = authUrl;
    } catch (err) {
      this.setState({
        step: 'error',
        error: `Failed to start OAuth flow: ${err.message}`
      });
    }
  }

  exchangeCodeForTokens(code) {
    if (this.state.isExchanging) {
      //console.log("Exchange process already initiated. Skipping...");
      return;
    }
    this.setState({ isExchanging: true }); // Set flag
    const codeVerifier = localStorage.getItem('canvaCodeVerifier');
    //alert("exchangeCodeForTokens="+code+" verifier="+codeVerifier);
    //console.log("Code verifier:", codeVerifier);
    if (!codeVerifier || codeVerifier.length === 0 || codeVerifier === 'undefined') {
      this.setState({
        step: 'error',
        error: `Missing code_verifier in popup sessionStorage! Please close this window and try again without refreshing.`,
        isExchanging: false, // Reset flag
      });
      return;
    }
    //console.log("Exchange URL:", ETVConstants.getServerBase() + `/canva/exchange?code=${code}&code_verifier=${codeVerifier}`);
    //if(true) return;
    axios.post(ETVConstants.getServerBase() + '/canva/exchange', { "etv_source":"elevator.tv" ,"code":code, "code_verifier":codeVerifier, "redirect_uri":CANVA_REDIRECT_URI }, {
	  headers:{
		user_id:sessionStorage.getItem('canvaOAuthUserId') || localStorage.getItem('etv.user_id'),
		access_token:sessionStorage.getItem('canvaOAuthAccessToken') || localStorage.getItem('etv.access_token')
	  }
	})
      .then((res) => {
        //alert(JSON.stringify(res));
        //console.log("Token exchange successful:", res.data);
        if (window.opener) {
          //alert("posting message: "+res.data);
		  const openerOrigin = sessionStorage.getItem('canvaOAuthOpenerOrigin') || CANVA_REDIRECT_ORIGIN;
		  localStorage.removeItem('canvaOAuthState');
		  localStorage.removeItem('canvaCodeVerifier');
		  localStorage.removeItem('canvaCode');
		  sessionStorage.removeItem('canvaOAuthOpenerOrigin');
		  sessionStorage.removeItem('canvaOAuthUserId');
		  sessionStorage.removeItem('canvaOAuthAccessToken');
          window.opener.postMessage({ tokenData: res.data }, openerOrigin);
        }
        hasMounted = false;
        window.close();
      })
      .catch((err) => {
        //console.error("Token exchange failed:", err);
        this.setState({
          step: 'error',
          error: `Token exchange failed: ${err.message}`,
          isExchanging: false, // Reset flag
        });
      });
  }

  render() {
    const { step, error } = this.state;

    if (step === 'error') {
      return (
        <div style={{ color: 'red' }}>
          <h3>OAuth Error</h3>
          <p>{error}</p>
        </div>
      );
    }
    if (step === 'exchanging') {
      return <div>Exchanging code for tokens…</div>;
    }
    return <div>Initializing…</div>; // default
  }
}

export default CanvaPopup;
